<!-- upload-progress-popup.component.html -->
<div class="upload-progress-popup">
  <mat-card class="progress-card">
    <div class="progress-header">
      <div class="file-info">
        <span class="file-name">{{filename}}</span>
        <span class="file-size">{{progress}}% Complete</span>
      </div>
      <button mat-icon-button (click)="closePopup()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-progress-bar class="progress-bar" mode="determinate" [value]="progress"></mat-progress-bar>
  </mat-card>
</div>
